<!-- Dialog: CANCEL TARDE CONFIRM  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="algo_params_dialog bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> Edit Algo Parameters </p-header>
  <div>
    <div class="algo_params__top__summary__wrapper" style="display: block">{{description}}</div>
    <div class="order-entry__panel-financials__algo__pane">
      <oe-panel-algo-params
        *ngIf="config != null"
        #panelAlgoParams
        [entryType]="1"
        [algoType]="config.algoType"
        [ccyCode]="config.currencyCode"
        [orderAmt]="config.orderAmount"
        [ccyPairCode]="config.currencyPair"
        [ccyPairInverted]="config.invertedPair"
        [rate]="config.rate"
        [strategyParameters]="algoParams"
        [suppressWindowResizeUpdates]="true"
        [scrollMaxHeight]="555"
      >
      </oe-panel-algo-params>
    </div>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="closeDialog()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary-bold"
      (click)="actionConfirmed()"
      label="Save"
    ></button>
  </p-footer>
</p-dialog>
